import { render, staticRenderFns } from "./vResetPasswords.vue?vue&type=template&id=4c36042a&scoped=true"
import script from "./vResetPasswords.vue?vue&type=script&lang=js"
export * from "./vResetPasswords.vue?vue&type=script&lang=js"
import style0 from "./vResetPasswords.vue?vue&type=style&index=0&id=4c36042a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c36042a",
  null
  
)

export default component.exports